export default "/dist/files/icone_lien_video.6b2d871bbf6cb7a92ffad74ede8243f2.svg";